import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-creative-writing",
    templateUrl: "./creative-writing.component.html",
    styleUrls: ["./creative-writing.component.css"],
    standalone: false
})
export class CreativeWritingComponent {
  // Data for all weeks
  weeks = [
    {
      title: "Week 1: Strong Beginnings",
      content: `
     <p><strong>Focus:</strong> Openings that hook the reader</p>
    <p><strong>Skills:</strong></p>
     <ul>
     <li>Introduction, Types of Creative Writings and Exam Style Questions</li>
    <li>Introduces sentence variation and warms up creativity.</li>
     <li>Using action, dialogue, or description to start</li>
     <li>Introducing character & setting quickly</li>
    </ul>
    <p><strong>Practical / Exercise:</strong></p>
     <ul>
     <li>Class practical 01 & Feedback</li>
     <li>Home Work exercise 01 & Feedback</li>
     </ul>
     `,
    },
    {
      title: "Week 2: Character and Setting",
      content: `
     <p><strong>Focus:</strong> Vivid and believable details</p>

    <p><strong>Skills:</strong></p>

     <ul>
     <li>Sensory Language and its use</li>
    <li>Show, don’t tell</li>
     <li>Using action, dialogue, or description to start</li>
     <li>5 senses for setting</li>
     <li> Emotion & reaction for characters </li>
    </ul>

    <p><strong>Practical / Exercise:</strong></p>

     <ul>
     <li>Class practical 02 & Feedback</li>
     <li>Home Work exercise 02 & Feedback</li>
     </ul>
     `,
    },
    {
      title: "Week 3: Plot and Planning",
      content: `
     <p><strong>Focus:</strong> Clear structure (Beginning – Middle – End)</p>

    <p><strong>Skills:</strong></p>

     <ul>
     <li>Literary Devices - Types and Practice</li>

     <li>Similes, metaphors, personification</li>

     <li>Building tension</li>

     <li>Including a problem and resolution</li>

    </ul>

    <p><strong>Practical / Exercise:</strong></p>

     <ul>
     <li>Class practical 03 & Feedback</li>
     <li>Home Work exercise 03 & Feedback</li>
     </ul>
     `,
    },
    {
      title: "Week 4: Dialogue and Action",
      content:  `
      <p><strong>Focus:</strong> Descriptive Writing - Image and scenario based questions</p>
 
     <p><strong>Skills:</strong></p>
 
      <ul>
      <li>Punctuating dialogue correctly</li>
 
      <li>Action beats instead of “he said”</li>
 
 
     </ul>
 
     <p><strong>Practical / Exercise:</strong></p>
 
      <ul>
      <li>Class practical 04 & Feedback</li>
      <li>Home Work exercise 04 & Feedback</li>
      </ul>
      `,
    },
    {
      title: "Week 5: Vocabulary and Style Boost",
      content: `
      <p><strong>Focus:</strong> Story Creation and Story Completion Questions</p>
 
     <p><strong>Skills:</strong></p>
 
      <ul>
      <li>Using ambitious words naturally</li>
 
      <li>Punctuating dialogue correctly</li>
 
 
     </ul>
 
     <p><strong>Practical / Exercise:</strong></p>
 
      <ul>
      <li>Class practical 05 & Feedback</li>
      <li>Home Work exercise 05 & Feedback</li>
      </ul>
      `,
    },
    {
      title: "Week 6: Timed Practice and Editing",
      content: `
      <p><strong>Focus:</strong> Instructional Writing, Newspaper Article and Journal Entry, Persuasive writing</p>
 
     <p><strong>Skills:</strong></p>
 
      <ul>
      <li>Writing under time</li>
 
      <li>Self-editing checklist</li>
 
 
     </ul>
 
     <p><strong>Practical / Exercise:</strong></p>
 
      <ul>
      <li>Class practical 06 & Feedback</li>
      <li>Home Work exercise 06 & Feedback</li>
      </ul>
      `,
    },
    {
      title: "Week 7: Checking, Correcting & Organising",
      content: `
      <p><strong>Focus:</strong> Self-editing checklist & validation</p>
 
     <p><strong>Skills:</strong></p>
 
      <ul>
      <li>Long Answer type questions, </li>
 
      <li>Proofreading, Structure, SPaG and </li>

      <li>Sentence Variation</li>

       <li>Self-editing checklist</li>
 
 
     </ul>
 
     <p><strong>Practical / Exercise:</strong></p>
 
      <ul>
      <li>Class practical 07 & Feedback</li>
      <li>Home Work exercise 07 & Feedback</li>
      </ul>
      `,
    },
    {
      title: "Week 8: Exam Focused",
      content: `
      <p><strong>Focus:</strong> CSSE, HBS, FSCE, SET & Independent Schools</p>
 
     <p><strong>Skills:</strong></p>
 
      <ul>
      <li>Overview of CSSE, FSCE and HBS Patterns & Questions </li>
 
      <li>Proofreading, Structure, SPaG and </li>

      <li>Marking Scheme</li>

       <li>Tips Tricks to get exam ready</li>
 
     </ul>
      `,
    },
  ];

  openIndex = 0; // open the first by default

  toggleAccordion(index: number) {
    this.openIndex = this.openIndex === index ? -1 : index;
  }

  openExternalLink(): void {
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/fcdae201654815f849f0ce15d194cd8d';
  }

  bookSlot():void{
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/fcdae201654815f849f0ce15d194cd8d/book-a-slot';
  }
}
